import { NavLink, Outlet, useNavigate } from 'react-router';
import { useLogout, useMe } from '../api/queries';

export function AdminLayout() {
  const { data: user } = useMe();
  const logout = useLogout();
  const navigate = useNavigate();

  return (
    <div className="admin">
      <header className="topbar">
        <div className="topbar-inner">
          <NavLink to="/admin" className="brand">
            <span className="brand-mark">99</span> Client Forms
          </NavLink>
          <nav className="nav">
            <NavLink to="/admin/links">Client links</NavLink>
            <NavLink to="/admin/templates">Templates</NavLink>
          </nav>
          <div className="topbar-user">
            <span className="muted hide-sm">{user?.email}</span>
            <button
              className="btn btn-ghost btn-sm"
              onClick={() => logout.mutate(undefined, { onSettled: () => navigate('/login') })}
            >
              Log out
            </button>
          </div>
        </div>
      </header>
      <main className="container">
        <Outlet />
      </main>
    </div>
  );
}
